/**
 * =========================================================================================
 * Component - Date Range Picker
 * =========================================================================================
 *
 **/

import React, {useEffect, useMemo, useRef, useState} from 'react';
import {defaultInputRanges, defaultStaticRanges, getDate, showFilterDateRange} from '../common/function';
import useWindowSize from '../hooks/useWindowSize';
import {DateRangePicker} from 'react-date-range';
import * as Icon from 'ubs-icons';
import UPopup from "ubs-framework/v2/UPopup";
import {COLOR} from "../common/constant";

const UDateRangePicker = (props) => {

    const dateRangePickerRef = useRef();
    const size = useWindowSize();
    const checkRange = useMemo(() => !!(props?.startDate && props?.endDate), [props?.startDate, props?.endDate])

    const [ranges, setRanges] = useState([]);

    useEffect(() => {
        if (checkRange) {
            const startDate = new Date(props.startDate);
            const endDate = new Date(props.endDate);

            if (startDate instanceof Date && !isNaN(startDate) && endDate instanceof Date && !isNaN(endDate)) {
                setRanges([{
                    startDate,
                    endDate,
                    key: 'selection'
                }]);
            } else {
                setRanges([]);
            }
        } else {
            setRanges([]);
        }
    }, [props.startDate, props.endDate, checkRange]);

    useEffect(() => {
        if (props?.clearState) clearState();
    }, [props?.clearState]);

    const handleChange = (value) => setRanges([{startDate: new Date(value?.selection?.startDate), endDate: new Date(value?.selection?.endDate), key: 'selection'}])

    const closeRanges = () => {
        if (props?.onClose && ranges[0]?.startDate) props?.onClose({startDate: new Date(getDate(ranges[0]?.startDate)), endDate: new Date(getDate(ranges[0]?.endDate, 'end'))})
    }
    const clearRanges = (e) => {
        e?.preventDefault()
        e?.stopPropagation()
        if (props?.onClose) props?.onClose(null)
        setRanges([])
    }

    const clearState = () => {
        setRanges(checkRange ? [{
            startDate: new Date(props?.startDate),
            endDate: new Date(props?.endDate),
            key: 'selection'
        }] : []);
    }
    return (
        <UPopup
            params={{
                className: `u_daterangepicker ${props?.tooltipClass ? props.tooltipClass : ''}`,
                position: props?.calendarPosition ? props?.calendarPosition : ["bottom right", "top right"],
                on: ['click'],
                open: false,
                ref: dateRangePickerRef,
                arrow: false,
                contentStyle: {zIndex: 1112},
                keepTooltipInside: false,
                onClose: () => closeRanges(),
                ...(props?.params || {}),
            }}
            desc={<div className={`u_daterangepicker   ${!props?.extraRanges && "rangesType"}`}>
                <DateRangePicker
                    ranges={!!ranges?.length ? ranges : [{startDate: new Date(), endDate: new Date(), key: 'selection'}]}
                    staticRanges={defaultStaticRanges?.filter(_=> (!_?.rangeType || Boolean(!props?.extraRanges) === Boolean(_?.rangeType)))}
                    inputRanges={defaultInputRanges}
                    showSelectionPreview={true}
                    onChange={handleChange}
                    {...props}
                    months={size < 768 ? 1 : 2}
                    direction={size > 1024 ? 'horizontal' : 'vertical'}
                />
            </div>}
        >
            {/* Optional custom trigger (e.g. a date pill); defaults to the filter chip. */}
            {props?.trigger || (
            <div className={`u_filter-container ${checkRange ? 'u_filter-daterange-active' : ''}`}>
                <span className="u_calendar-icon"><Icon.Calendar size={14} fill={checkRange ? `#007AFF` : `#73788B`}/></span>
                <p> {showFilterDateRange(ranges, props?.filterName)} </p>
                {checkRange && props?.isClearable && <span className="u_date-close u_flex" onClick={clearRanges}><Icon.Close size={12} fill={COLOR.u_blue}/></span>}
            </div>)}
        </UPopup>
    );
}

export default UDateRangePicker;
